<div class="row">
  <point-edit
    [processing]="processing"
    [point]="point"
    (toggleSavePoint)="savePoint($event)"
    (toggleCancel)="cancel()"
  ></point-edit>
</div>
